import { motion, useReducedMotion } from 'framer-motion';
import { Sparkle } from './icons/Sparkle';

/**
 * The session's opening prompt, shown in the empty transcript directly above the composer: it says
 * what this console is for and how to start a turn, and it is spent by the first thing the user says
 * or types (see `introDismissed` in the session store).
 *
 * It animates in but not out: the first keystroke or the press of the mic button takes it down at
 * once, which is what makes the console feel like it was listening.
 */
export function SessionIntro() {
  const reduceMotion = useReducedMotion();
  const offset = reduceMotion ? 0 : 10;

  return (
    <motion.section
      initial={{ opacity: 0, y: offset }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.32, ease: [0.16, 1, 0.3, 1] }}
      className="flex justify-center py-12"
    >
      <div className="flex items-center gap-3 text-left">
        <span className="border-accent/30 bg-accent/10 text-accent-soft grid size-11 shrink-0 place-items-center rounded-2xl border">
          <Sparkle className="size-5" />
        </span>
        <div className="space-y-1">
          <h2 className="text-2xl font-semibold tracking-tight">Talk to the agent</h2>
          <p className="text-muted max-w-md text-sm leading-relaxed">
            Hold <Kbd>Space</Kbd> to speak, or type below. Every frame is recorded in the debug
            drawer.
          </p>
        </div>
      </div>
    </motion.section>
  );
}

function Kbd({ children }: { readonly children: string }) {
  return (
    <kbd className="border-line bg-raised text-text rounded border px-1.5 py-0.5 font-sans text-[11px] font-semibold">
      {children}
    </kbd>
  );
}
